import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import { GeoIpDto } from './fetch-location-by-ip.types';

type FetchLocationByIpOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};

export function fetchLocationByIp(
  url: string,
  options?: FetchLocationByIpOptions,
): Promise<IHttpResponse<GeoIpDto>> {
  const request: IHttpRequest<void> = {
    url,
    method: 'GET',
    schemas: {
      response: GeoIpDto,
    },
    ...options,
  };

  return fetchBasedCall(request);
}
